import Index from "./pages/Index";

export function AppRouter() {
  return <Index />;
}

export default AppRouter;
